<template>
  <div role="region" class="appliedfilters">
    <client-only>
      <ul>
        <li
          v-for="filter in filtersToShow"
          :key="filter.key"
          class="save-search-li"
        >
          <button
            :disabled="filter.category === 'occasion'"
            @click="$emit('filterToggled', filter)"
          >
            {{ filter.chipName || filter.name }}
          </button>
        </li>
        <li v-if="selectedFilters.length > 2 && !fixExpanded">
          <button class="filter-noremove" @click="expanded = !expanded">
            {{ expanded ? 'Show Less' : `+${selectedFilters.length - 2}` }}
          </button>
        </li>

        <li v-if="selectedFilters.length > 0 && !hideClear">
          <nuxt-link class="clear" :to="clearFiltersUrl">
            Clear Filters ({{ selectedFilters.length }})
          </nuxt-link>
        </li>
        <li v-else-if="!hideClear">
          <button class="filter-noremove">All Wines</button>
        </li>
        <li v-if="!hideSave">
          <button
            class="save-search"
            @click="$store.dispatch('toggleSavedSearchModal')"
          >
            Save My Search & Notify Me
          </button>
        </li>
      </ul>
    </client-only>
  </div>
</template>

<script>
export default {
  name: 'SelectedFilterChips',
  props: {
    selectedFilters: {
      type: Array,
      required: true,
    },
    clearFiltersUrl: {
      type: String,
      required: true,
    },
    hideClear: {
      type: Boolean,
      default: false,
    },
    hideSave: {
      type: Boolean,
      default: false,
    },
    fixExpanded: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['filterToggled'],
  data() {
    return {
      expanded: false,
    }
  },
  computed: {
    filtersToShow() {
      if (this.expanded || this.fixExpanded) return this.selectedFilters
      else return this.selectedFilters.slice(0, 2)
    },
  },
}
</script>
